import { render, staticRenderFns } from "./List-Invoice-COD.vue?vue&type=template&id=5f56a5cc&scoped=true"
import script from "./List-Invoice-COD.vue?vue&type=script&lang=js"
export * from "./List-Invoice-COD.vue?vue&type=script&lang=js"
import style0 from "./List-Invoice-COD.vue?vue&type=style&index=0&id=5f56a5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56a5cc",
  null
  
)

export default component.exports